import { from as observableFrom, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { NavigationService } from '../../../core/service/navigation.service';
import { Contract } from '../../model/contract';
import { LeaseAgreementStatus } from '../../model/const/enums';
import { LeaseAgreementCategory } from '../../../rent/model/const/enums';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class VoidContractCommandHandler implements ICommandHandler {
  constructor(
    private _navigationService: NavigationService,
    private _messageService: MessageService
  ) {}

  canExecute(command: Command): boolean {
    if (command instanceof Command && command.context instanceof Contract) {
      if (command.id !== leaseAgreementCommand.void) {
        return false;
      }

      if (command.context.status === LeaseAgreementStatus.Voided) {
        this._messageService.showMessage('ERROR.VOID_VOIDED_LEASE_AGREEMENT');
        return false;
      }

      if (command.context.category === LeaseAgreementCategory.CooperativeHousing && command.context.lastBillingDate != null && command.context.lastBillingDate.hasValue()) {
        this._messageService.showMessage('ERROR.VOID_ONLY_BRF_STATUS_VALID_AND_COMING_CAN_BE_VOIDED')
        return false;
      }
      return true;
    }

    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return observableFrom(this._navigationService.navigateChild([command.context.id, 'void-leaseagreement']));
    }
  }
}
